import BurgerIcon from "~/icons/BurgerIcon";
import LogoIcon from "~/icons/LogoIcon";
import { classNames } from "~/utils/utils";

import "./style.less";

interface IHeaderLogo {
	compact?: boolean;
	onClick?: () => void;
	onLogoClick?: () => void;
}

export default function HeaderLogo({
	compact = false,
	onClick = () => {},
	onLogoClick = () => {},
}: IHeaderLogo) {
	function getClassName() {
		return classNames(["headerLogo", ...compact ? ["compact"] : []]);
	}

	return <div className={getClassName()}>
		<button type="button" className="headerLogo__burgerBtn" onClick={onClick}>
			<BurgerIcon />
		</button>
		<button type="button" className="headerLogo__logoBtn" onClick={onLogoClick}>
			<LogoIcon />
		</button>
	</div>;
}
